import { Component, OnInit } from '@angular/core';
import { MultistepsService } from '@app/modules/builder/base/services';
import { SessionService, StepsIdEnum, LookupsService, EnvironmentService, ConstantsService, CompaniesEnum } from '@app/base/core';
import { BuilderService } from '@app/modules/builder/base';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CanComponentDeactivate, compareObjects } from '@app/base/shared';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MapIntegration } from '@app/shared/services/GISIntegration';
import { PlatformLocation } from '@angular/common';
import { AlertService } from '@app/base/alerts/alert.service';
declare var swal: any;
@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit, CanComponentDeactivate {
  form: FormGroup;
  mapIntegration: any;
  alertMsg: any = [];
  serviceAddress: any = {};
  servicableLocation: string;
  locationDetails: any = {};
  gisObj: any;
  iframeUrl: SafeResourceUrl;
  gisUrl: any;
  flag;
  projectId;
  lat: any = null;
  lng: any = null;
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  companiesEnum: typeof CompaniesEnum = CompaniesEnum;
  constructor(private router: Router, public wizardSvc: MultistepsService, public sessionSvc: SessionService,
    private lookupSvc: LookupsService,
    private alertService: AlertService,
     public sanitizer: DomSanitizer, private builderSvc: BuilderService,
    public environmentSvc: EnvironmentService, public constSvc: ConstantsService, public browser: PlatformLocation) {
    this.wizardSvc.syncActiveStep(StepsIdEnum.LOCATION);
    const state = this.wizardSvc.serviceAddress !== null ?
    (this.wizardSvc.serviceAddress.state ? this.wizardSvc.serviceAddress.state.short_name : sessionSvc.paramLdc ) : sessionSvc.paramLdc;
    const company = this.getCompanyFromState(state);
    if (this.wizardSvc.changeAddressClicked) {
      this.lat = this.wizardSvc.serviceAddress.coordinates.lat;
      this.lng = this.wizardSvc.serviceAddress.coordinates.lng;
      this.wizardSvc.changeAddressClicked = false;
      if (this.lat !== undefined && this.lng !== undefined) {
        this.gisUrl = this.environmentSvc.gisBaseURL + company + '&lat=' + this.lat + '&lon=' + this.lng;
      }
    } else if (this.builderSvc.individualServiceClicked) {
      const newGisUrl = this.environmentSvc.gisBaseURL.split('&ldc=');
      this.gisUrl = newGisUrl[0] + '&LotType=1';
    } else if (this.builderSvc.reassigmentFlag === 1) {
      let address;
      this.sessionSvc.GridData.subscribe(
        success => {
          address = success.serviceAddress;
      });
      this.lat = address.coordinates.lat;
      this.lng = address.coordinates.lng;
      const companies = this.getCompanyFromState(address.state.short_name);
      if (this.lat !== undefined && this.lng !== undefined) {
        this.gisUrl = this.environmentSvc.gisBaseURL + companies + '&lat=' + this.lat + '&lon=' + this.lng;
      }
      this.builderSvc.reassigmentFlag = 0;
    } else {
      this.gisUrl = this.environmentSvc.gisBaseURL + company;
    }
    this.mapIntegration = new MapIntegration(this.gisMessageHandler.bind(this), '', 'GisFrame');
  }
  // To get company name from state
  getCompanyFromState(state: any) {
    let company;
    if (state === this.companiesEnum.GA) {
      company = 'AGLC';
    } else if (state === this.companiesEnum.FL) {
      company = 'FCG';
    } else if (state === this.companiesEnum.TN) {
      company = 'CGC';
    } else if (state === this.companiesEnum.VA) {
      company = 'VNG';
    }
    return company;
  }
  ngOnInit() {
    this.browser.onPopState(() => {
      let url = window.location.href;
      url = url.replace('review', 'location');
      window.history.pushState(null, '', url);
       // Load common lookup values
       const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
        if (subscribe && val) {
          subscribe.unsubscribe();
        }
        // Loading banner message for Location
        if (val) {
          this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Location Builder'
          ));
          this.alertService.info(this.alertMsg.message);
        }
      });
    });
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.LOCATION).form;
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.gisUrl);
  }
  next() { this.wizardSvc.nextStep(); } // Navigate to next page
  back() { this.wizardSvc.previousStep(); }// Navigate to previous page
  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState: RouterStateSnapshot) {
    if (this.wizardSvc.maxCompletedStep < 1) { return true; } // User didn't complete any step, so they can leave.
    return this.wizardSvc.canDeactivateStep(route, state, nextState);
  }

  // New BCA creation
  createNewBCA() {
    const msg = document.createElement('div');
    const message = this.constSvc.serviceProvideCnfirmMsg;
    msg.innerHTML = message;
    if (this.servicableLocation === 'True') {
      swal({
        content: msg, icon: 'assets/images/icons/icon_94_tumbs-up-green.svg',
        buttons: {
          cancel: { text: 'Cancel', visible: true, value: false, closeModal: true },
          confirm: { text: 'Proceed', value: true, closeModal: true }
        }
      }).then((result) => {
        if (!result) { return; }
        const step = this.wizardSvc.steps.find(s => s.id === StepsIdEnum.TYPE);

        if (this.gisObj.commandOrEventName === this.constSvc.addressSelectedForNewBCA && this.wizardSvc.addressChanged) {
          this.wizardSvc.serviceAddress = this.locationDetails;
          this.serviceAddress.state = this.wizardSvc.serviceAddress.state.short_name;
          this.serviceAddress.city = this.wizardSvc.serviceAddress.city;
          this.serviceAddress.county = this.wizardSvc.serviceAddress.county;
          this.serviceAddress.zip = this.wizardSvc.serviceAddress.zip;
          if (this.form.controls['locationStreetName'].value !== null && this.form.controls['locationStreetName'].value !== '' &&
            this.form.controls['locationStreetName'].value !== undefined) {
            this.serviceAddress.streetName = this.form.controls['locationStreetName'].value;
          } else {
            this.serviceAddress.streetName = this.wizardSvc.serviceAddress.street_name;
          }
          if (this.form.controls['locationStreetNumber'].value !== null && this.form.controls['locationStreetNumber'].value !== '' &&
            this.form.controls['locationStreetNumber'].value !== undefined) {
            this.serviceAddress.streetNumber = this.form.controls['locationStreetNumber'].value;
          } else {
            this.serviceAddress.streetNumber = this.wizardSvc.serviceAddress.street_number;
          }
          this.lookupSvc.resolveBuilderServiceAddressLookups(
            this.serviceAddress);
        }
        if (step && step.form.value.propertyType !== null) {
          const formValue = step.form.value.propertyType;
          this.lookupSvc.loadBuilderBcaLookups(formValue.id, this.wizardSvc.serviceAddress.state.short_name);
          this.serviceAddress.state = this.wizardSvc.serviceAddress.state.short_name;
          this.serviceAddress.city = this.wizardSvc.serviceAddress.city;
          this.serviceAddress.county = this.wizardSvc.serviceAddress.county;
          this.serviceAddress.zip = this.wizardSvc.serviceAddress.zip;
          if (this.form.controls['locationStreetName'].value !== null && this.form.controls['locationStreetName'].value !== '' &&
            this.form.controls['locationStreetName'].value !== undefined) {
            this.serviceAddress.streetName = this.form.controls['locationStreetName'].value;
          } else {
            this.serviceAddress.streetName = this.wizardSvc.serviceAddress.street_name;
          }
          if (this.form.controls['locationStreetNumber'].value !== null && this.form.controls['locationStreetNumber'].value !== '' &&
            this.form.controls['locationStreetNumber'].value !== undefined) {
            this.serviceAddress.streetNumber = this.form.controls['locationStreetNumber'].value;
          } else {
            this.serviceAddress.streetNumber = this.wizardSvc.serviceAddress.street_number;
          }
          this.serviceAddress.propertyType = formValue.id;
          this.lookupSvc.resolveBCAFoundBuilder(
            this.serviceAddress
            );
       }
        // navigate to first step of multistep form
        this.lookupSvc.serviceAddressLookupsLoaded$.subscribe(loaded => {
          if (loaded) {
            this.wizardSvc.duplicatedRequest = false;
            this.wizardSvc.maxCompletedStep = StepsIdEnum.TYPE;
            this.next();
          }
        });
      });
    } else {
      this.sorryNotification();
    }
  }
// For checking serviceablearea and creating New BCA
  gisMessageHandler(message: any) {
    const obj = JSON.parse(message.data);
    this.gisObj = obj;
    if (obj.commandOrEventName === this.constSvc.serviceableAreaCheck) {
      this.servicableLocation = obj.payload.isServiceable;
      if (this.servicableLocation === this.constSvc.False) {
        let address, state;
        this.locationDetails = {};
        address = obj.payload.address.address;
        state = this.lookupSvc.states.find(x => x.id.toUpperCase() === address.state.toUpperCase());
        this.locationDetails.state = { long_name: state.itemName, short_name: state.id };
        this.createNewBCA();
      }
    } else if (obj.commandOrEventName === this.constSvc.addressSelectedForNewBCA) {
      this.servicableLocation = obj.payload.isServiceable;
      let address, state;
      this.locationDetails = {};
      address = obj.payload.address.address;
      this.getServiceAddress(address);
      this.wizardSvc.buildingId = null;
      this.locationDetails.formattedAddress = address.formatted_address;
      state = this.lookupSvc.states.find(x => x.id.toUpperCase() === address.state.toUpperCase());
      this.locationDetails.street_number = address.street_number;
      this.locationDetails.street_name = address.street_name;
      this.locationDetails.city = address.city;
      this.locationDetails.state = { long_name: state.itemName, short_name: state.id };
      this.locationDetails.zip = address.zip;
      this.locationDetails.county = address.county;
      this.locationDetails.localDistrict = address.localDistrict;
      this.locationDetails.localDistrictCd = address.localDistrictCode;
      this.locationDetails.xCoordinate = obj.payload.X_COORDINATE;
      this.locationDetails.yCoordinate = obj.payload.Y_COORDINATE;
      this.locationDetails.coordinates = {};
      this.locationDetails.coordinates.lat = obj.payload.coordinates.lat;
      this.locationDetails.coordinates.lng = obj.payload.coordinates.lon;
      this.locationDetails.serviceCenter = obj.payload.serviceCenter;
      this.createNewBCA();
    } else if (obj.commandOrEventName === this.constSvc.requestSelectedForCreate) {
      let grId, projectNumber;
      this.locationDetails = {};
      this.locationDetails.coordinates = {};
      const address = obj.payload.address;
      const state = this.lookupSvc.states.find(x => x.id.toUpperCase() === address.state.toUpperCase());
      this.locationDetails.state = { long_name: state.itemName, short_name: state.id };
      this.locationDetails.coordinates.lat = obj.payload.coordinates.lat;
      this.locationDetails.coordinates.lng = obj.payload.coordinates.lon;
      grId = obj.payload.requestId;
      this.projectId = obj.payload.bcaId;
      projectNumber = null;
      const projectDetails: ProjectDetails = {
        grId: grId,
        stateCd: state.id,
        projectNumber: projectNumber,
        serviceAddress: this.locationDetails
      };
          this.sessionSvc.GetGrid(projectDetails);
          this.flag = 'l-blr';
          this.router.navigate([
            this.sessionSvc.paramLdc.toLowerCase(),
            'builder',
            'requestlot',
             grId,
            this.flag
          ]);
      }
  }
  // Sorry Notification for showing non availability of providing natural gas
  sorryNotification() {
    const text = this.constSvc.sorryNotificationText;
    const textAGL = this.constSvc.sorryNotificationTextAGL;
    const msg1 = document.createElement('div');
    if (this.locationDetails.state.long_name === this.constSvc.georgia) {
      msg1.innerHTML = textAGL;
    } else {
      msg1.innerHTML = text;
    }

    swal({
      icon: 'assets/images/icons/no-service-in-locality icon.png',
      content: msg1,
      buttons: {
        cancel: { text: 'Ok', visible: true, value: false, closeModal: true },
      },
    });
  }

  getServiceAddress(address: any) {
    // If address is null or different than currently stored address update it and reload it from server.
    if (!this.wizardSvc.serviceAddress) {
      this.updateServiceAddressandLookups();
    } else if (!compareObjects(this.wizardSvc.serviceAddress.formattedAddress, address)) {
      this.updateServiceAddressandLookups();
    }
  }

  updateServiceAddressandLookups() {
    // uncheck same as service address and clear mailing address data.
    this.wizardSvc.addressValidationDone = false;
    this.wizardSvc.addressChanged = true;
  }

  ngOnDestroy() {
    this.builderSvc.individualServiceClicked = false;
  }
}

interface ProjectDetails {
  grId: number;
  stateCd: string;
  projectNumber: number;
  serviceAddress: any;
}
